<template>
  <div id="geo-options">
    <!-- Pull up their data, with an add button -->
    <!-- table of students -->
    <b-container id="options-table" fluid>
      <b-row>
        <b-col>
          <table class="table table-striped table-hover">
            <caption>Drag and drop to rearrange</caption>
            <thead class="thead-light">
              <tr>
                <th class="col-md-5" scope="col">Regions:</th>
                <th class="col-md-2" scope="col"></th>
              </tr>
            </thead>
            <div class="input-group mb-3">
              <input
                v-model="regionToAdd"
                type="text"
                class="form-control"
                placeholder="Region to add"
                aria-label="Region to add"
                aria-describedby="basic-addon2"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click.prevent="addRegion"
                >Add</button>
              </div>
            </div>
            <draggable
              v-model="regions"
              @start="drag = true"
              @end="drag = false, saveRegions()"
              tag="tbody"
            >
              <tr v-for="option in regions" :key="option.id">
                <td>
                  <h4 @click="regionSelected(option.option)">{{ option.option }}</h4>
                </td>
                <td>
                  <b-link class="delete" @click.stop="removeRegion(option)">X</b-link>
                </td>
              </tr>
            </draggable>
          </table>
        </b-col>
        <b-col>
          <table class="table table-striped table-hover">
            <caption v-if="regionSelectedBool">Drag and drop to rearrange</caption>
            <thead class="thead-light">
              <tr>
                <th class="col-md-5" scope="col">{{districtsTitle}}</th>
                <th class="col-md-2" scope="col"></th>
              </tr>
            </thead>
            <div class="input-group mb-3 text-center" v-if="regionSelectedBool">
              <input
                v-model="districtToAdd"
                type="text"
                class="form-control"
                placeholder="District to add"
                aria-label="District to add"
                aria-describedby="basic-addon2"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click.prevent="addDistrict"
                >Add</button>
              </div>
            </div>
            <draggable
              v-model="districts"
              @start="drag = true"
              @end="drag = false, saveDistricts()"
              tag="tbody"
            >
              <tr v-for="option in districts" :key="option.id">
                <td>
                  <h4>{{ option.option }}</h4>
                </td>
                <td>
                  <b-link class="delete" @click.stop="removeDistrict(option)">X</b-link>
                </td>
              </tr>
            </draggable>
          </table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OptionsService from "../services/OptionsService";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";
import draggable from "vuedraggable";

export default {
  name: "GeoOptions",
  mixins: [flash, scrollTo],
  components: {
    draggable
  },
  props: ["optionKey"],
  data() {
    return {
      regions: [],
      districts: [],
      districtsTitle: "Select a Region...",
      regionToAdd: "",
      districtToAdd: "",
      regionId: "",
      districtId: "",
      regionSelectedBool: false,
      selectedRegion: ""
    };
  },
  methods: {
    ...mapActions({
      GET_OPTIONS: "optionsList/GET_OPTIONS",
      UPDATE_OPTIONS: "optionsList/UPDATE_OPTIONS"
    }),
    regionsTable() {
      this.regions = [];
      this.optionsList.forEach(element => {
        if (element.key == this.optionKey + "Regions") {
          this.regionId = element.id;
          element.values.forEach(value => {
            this.regions.push({
              id: element.values.indexOf(value),
              option: value
            });
          });
        }
      });
    },
    districtsTable() {
      this.districts = [];
      this.optionsList.forEach(element => {
        if (element.key == this.optionKey + this.selectedRegion + "Districts") {
          this.districtId = element.id;
          element.values.forEach(value => {
            this.districts.push({
              id: element.values.indexOf(value),
              option: value
            });
          });
        }
      });
    },
    regionSelected(region) {
      this.regionSelectedBool = true;
      this.selectedRegion = region;
      this.districtsTitle = region + "'s Districts:";
      this.districtsTable();
    },
    async saveRegions() {
      const props = {
        id: this.regionId,
        values: []
      };
      this.regions.forEach(optioni => {
        props.values.push(optioni.option);
      });
      await OptionsService.updateOptionsList(props);
      await this.GET_OPTIONS();
    },
    async addRegion() {
      const tempOption = {
        id: this.regions.length,
        option: this.regionToAdd
      };
      this.regions.push(tempOption);

      const props = {
        id: this.regionId,
        values: []
      };
      this.regions.forEach(optioni => {
        props.values.push(optioni.option);
      });

      const propsAdd = {
        key: this.optionKey + this.regionToAdd + "Districts"
      };

      await OptionsService.updateOptionsList(props);
      await OptionsService.addOptionsList(propsAdd);
      await this.GET_OPTIONS();
    },
    async removeRegion(option) {
      let index;
      const props = {
        id: this.regionId,
        values: []
      };
      this.regions.forEach(optioni => {
        if (optioni == option) {
          index = this.regions.indexOf(option);
        } else {
          props.values.push(optioni.option);
        }
      });
      this.regions.splice(index, 1);
      await OptionsService.updateOptionsList(props);
      await this.GET_OPTIONS();
    },
    async saveDistricts() {
      //console.log("Saving districts");
      const props = {
        id: this.districtId,
        values: []
      };
      this.districts.forEach(optioni => {
        props.values.push(optioni.option);
      });
      await OptionsService.updateOptionsList(props);
      await this.GET_OPTIONS();
    },
    async addDistrict() {
      const tempOption = {
        id: this.districts.length,
        option: this.districtToAdd
      };
      this.districts.push(tempOption);

      const props = {
        id: this.districtId,
        values: []
      };
      this.districts.forEach(optioni => {
        props.values.push(optioni.option);
      });
      await OptionsService.updateOptionsList(props);
      await this.GET_OPTIONS();
    },
    async removeDistrict(option) {
      let index;
      const props = {
        id: this.districtId,
        values: []
      };
      this.districts.forEach(optioni => {
        if (optioni == option) {
          index = this.districts.indexOf(option);
        } else {
          props.values.push(optioni.option);
        }
      });
      this.districts.splice(index, 1);
      await OptionsService.updateOptionsList(props);
      await this.GET_OPTIONS();
    },
    stopClick(row) {}
  },
  computed: {
    ...mapGetters({}),
    optionsList: {
      get() {
        return this.$store.state.optionsList.optionsList;
      }
    }
  },
  watch: {},
  created() {
    this.regionsTable();
  }
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}

.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}

table th,
table tr {
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.delete {
  color: #9f020f;
  font-weight: bold;
}
</style>
